import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

// ng-select2-component renders its focusable selection element with no
// accessible-name plumbing at all (no aria-label/aria-labelledby inputs, no
// combobox role), so the name has to be attached from outside — same
// approach as RatingLabelledbyDirective takes for ngx-bootstrap's rating.
@Directive({
  selector: '[appSelect2AriaLabel]',
  standalone: false
})
export class Select2AriaLabelDirective implements AfterViewInit {
  @Input('appSelect2AriaLabel') public label = '';

  constructor(private readonly _el: ElementRef) {}

  ngAfterViewInit(): void {
    if (!this.label) {
      return;
    }

    const host: HTMLElement = this._el.nativeElement;
    const target: HTMLElement =
      host.querySelector('.select2-selection') ||
      host.querySelector('[tabindex]') ||
      host;

    target.setAttribute('aria-label', this.label);
  }
}
